export enum DEFAULT_CONFIG {
    SGP2021 = 'sgp2021.interia.pl',
    MSG2021 = 'msg2021.interia.pl',
    DEFAULT = 'defaultConfig',
}
